import http from '@root/utils/axios/admin';

let state = {
    UsersList: [],
    User: {
        data: {},
        error: {}
    },
    Permissions: [],
    Roles: [],
}

let actions = {

    fetchUsersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/user/users', { params: filter }).then((response) => {
                commit('setUsers', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteUser({ commit }, id) {
        return http.delete('/user/users/' + id);
    },

    fetchUser({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/user/users/' + id).then((response) => {
                commit('setUser', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateUser({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/user/users', data).then((response) => {
                commit('setUser', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setUserError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateUser({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/user/users/' + data.id, data).then((response) => {
                commit('setUser', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setUserError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

    fetchPermissions({ commit }) {
        return new Promise((resolve, reject) => {
            http.get('/user/permissions').then((response) => {
                commit('setPermissions', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchRoles({ commit }) {
        return new Promise((resolve, reject) => {
            http.get('/user/roles').then((response) => {
                commit('setRoles', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

}


let mutations = {
    setUsers(state, data) {
        state.UsersList = data;
    },
    setPermissions(state, data) {
        state.Permissions = data;
    },
    setRoles(state, data) {
        state.Roles = data;
    },
    setUser(state, data) {
        state.User.data = data;
    },
    setUserError(state, error) {

        state.User.error = error.errors;
    },
    cleanUserError(state, error) {
        state.User.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}